import { Component, Input } from '@angular/core';
import { JobDetailsChecklistSubCategory } from '../../interfaces/checklist-category';

@Component({
  selector: 'checklist-category-item',
  templateUrl: './checklist-category-item.component.html',
  styleUrls: ['./checklist-category-item.component.scss'],
})
export class ChecklistCategoryItemComponent {
  @Input() subCategory: JobDetailsChecklistSubCategory;

  constructor() {}
}
